import React from 'react';
import { Link } from 'react-router-dom';
import { Check, Clock, Calendar, Target } from 'lucide-react';
export function Summer2026() {
  return <div className="w-full" data-id="element-816" data-mp="2c4ahwdhnxdo0">
      <Hero data-id="element-817" data-mp="2h340gkbt3uv1" />
      <LocationBanner data-id="element-818" data-mp="2h2ltasnlvw8c" />
      <IntroSection data-id="element-819" data-mp="2h22li4ro6o81" />
      <ProgramsAndSchedule data-id="element-820" data-mp="2h1kecd3gyplc" />
      <WeekAtAGlance data-id="element-821" data-mp="2h1at12tdd6lz" />
      <PeriodizedProgramming data-id="element-822" data-mp="2ludmzc226i2p" />
      <TestingAndRecovery data-id="element-823" data-mp="2lulyazij9fbs" />
      <MembershipIncludes data-id="element-824" data-mp="2lvx22zbzan2w" />
      <FinalCta data-id="element-825" data-mp="2qt70h4hci92v" />
    </div>;
}
/* ---------- HERO ---------- */
function Hero() {
  return <section className="relative bg-reach-black overflow-hidden py-20 md:py-28" data-id="element-826" data-mp="2vs06ycy7sztj">
      <div className="absolute inset-0 z-0" data-id="element-827" data-mp="2vtuqpnxr2lw1">
        <img src="https://images.unsplash.com/photo-1517649763962-0c623066013b?q=80&w=2400&auto=format&fit=crop" alt="Athletes training on indoor turf" className="w-full h-full object-cover grayscale contrast-125 opacity-60" data-id="element-828" data-mp="2ztd7q8mgactl" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/85 via-black/70 to-black/90" data-id="element-829" data-mp="1aep0elspvl2f" />
        <div className="absolute inset-0 bg-reach-red mix-blend-multiply opacity-[0.08]" data-id="element-830" data-mp="orow89v7lcc2" />
      </div>

      <div className="absolute inset-0 z-10 pointer-events-none overflow-hidden" data-id="element-831" data-mp="k101mlo8fz8p">
        <div className="absolute top-1/3 -left-40 w-[55%] h-2 bg-reach-red transform -rotate-[7deg] opacity-50" data-id="element-832" data-mp="jz5i9bsm0f6q" />
        <div className="absolute top-[44%] -left-40 w-[40%] h-2 bg-reach-red transform -rotate-[7deg] opacity-30" data-id="element-833" data-mp="b0a8jpqcwmyo" />
        <div className="absolute top-[55%] -left-40 w-[28%] h-2 bg-reach-red transform -rotate-[7deg] opacity-20" data-id="element-834" data-mp="17r2rqw8l6v4o" />
      </div>

      <div className="relative z-20 max-w-container mx-auto px-4 md:px-8 text-center" data-id="element-835" data-mp="13qai41vsyo7v">
        <p className="font-inter text-reach-red text-xs md:text-sm uppercase tracking-[0.3em] font-semibold mb-5" data-id="element-836" data-mp="yotkcf8m7hvi">
          Summer Season . June 1 to August 8
        </p>
        <h1 className="font-bebas text-white text-[56px] sm:text-7xl md:text-8xl lg:text-[120px] leading-[0.9] tracking-wide mb-5" data-id="element-837" data-mp="3jfu3ct6oedfu">
          Summer Training Schedule
        </h1>
        <p className="font-inter text-white/85 text-base md:text-xl max-w-2xl mx-auto leading-relaxed" data-id="element-838" data-mp="3ejdchr83dkz2">
          Speed, strength, and athletic development for youth, middle school,
          and high school athletes. Ten weeks, three programs, real progress you
          can measure.
        </p>
      </div>
    </section>;
}
/* ---------- LOCATION BANNER ---------- */
function LocationBanner() {
  return <section className="bg-reach-red" data-id="element-839" data-mp="2x7oj6v4qanmh">
      <div className="max-w-container mx-auto px-4 md:px-8 py-4 md:py-5" data-id="element-840" data-mp="2x6wp5oqs4xyb">
        <p className="font-inter text-white text-center text-xs md:text-sm uppercase tracking-[0.25em] font-semibold" data-id="element-841" data-mp="31yyby4lkq72l">
          Inside INPOWERiQ . 6051 Alma Rd . McKinney TX 75070 . 10 Week Season
        </p>
      </div>
    </section>;
}
/* ---------- INTRO SECTION ---------- */
function IntroSection() {
  return <section className="bg-white py-16 md:py-20" data-id="element-842" data-mp="2e9vj00lhorss">
      <div className="max-w-3xl mx-auto px-4 md:px-8 text-center" data-id="element-843" data-mp="2eb6oq5yhw9mj">
        <p className="font-inter text-reach-black text-lg md:text-xl leading-relaxed" data-id="element-844" data-mp="2j7dvu22mnr62">
          Reach Performance now trains out of INPOWERiQ Performance Center, a
          24,000 square foot facility with full strength and conditioning
          equipment, indoor turf, and an on-site recovery zone.
        </p>
      </div>
    </section>;
}
/* ---------- PROGRAMS AND SCHEDULE ---------- */
const PROGRAMS = [{
  title: 'Advanced Performance',
  eyebrow: 'High School . Ages 14+',
  duration: '75 minute sessions',
  schedule: ['Mon and Wed 9:00 to 10:15 AM', 'Tue and Thu 6:00 to 7:15 PM', 'Friday 1:00 to 2:15 PM']
}, {
  title: 'Performance Prep',
  eyebrow: 'Middle School . Ages 11 to 13',
  duration: '60 minute sessions',
  schedule: ['Mon and Wed 10:30 to 11:30 AM', 'Tue and Thu 5:00 to 6:00 PM', 'Friday 2:30 to 3:30 PM']
}, {
  title: 'Foundations',
  eyebrow: 'Youth . Ages 8 to 10',
  duration: '60 minute sessions',
  schedule: ['Tuesday 4:00 to 5:00 PM', 'Thursday 4:00 to 5:00 PM']
}];
function ProgramsAndSchedule() {
  return <section className="bg-reach-gray py-20 md:py-28" data-id="element-845" data-mp="zmbfa1tbntyk">
      <div className="max-w-container mx-auto px-4 md:px-8" data-id="element-846" data-mp="zkqomna4ov5z">
        <div className="text-center mb-14" data-id="element-847" data-mp="14ci7scqyfym3">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-848" data-mp="14dti6vewo4m6">
            Programs and Class Times
          </p>
          <h2 className="font-bebas text-4xl md:text-6xl tracking-wide" data-id="element-849" data-mp="bp5tsqyv0z4e">
            Choose Your Program
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-850" data-mp="gnz5cdul6g1x">
          {PROGRAMS.map(program => <div key={program.title} className="bg-white rounded-[4px] p-8 border-b-4 border-transparent hover:border-reach-red transition-colors" data-id="element-851" data-mp="lomz37a79azu">
              <p className="font-inter text-reach-red text-xs uppercase tracking-[0.25em] font-semibold mb-3" data-id="element-852" data-mp="1x1fnq97p1jbo">
                {program.eyebrow}
              </p>
              <h3 className="font-bebas text-3xl md:text-4xl tracking-wide leading-none mb-4" data-id="element-853" data-mp="3lll876b4dmr5">
                {program.title}
              </h3>
              <div className="flex items-center gap-2 mb-6 text-sm font-inter text-reach-black/70" data-id="element-854" data-mp="3hlugn0drr2lk">
                <Clock size={14} className="text-reach-red" data-id="element-855" data-mp="3cqx3bh9gi72v" />
                <span className="uppercase tracking-wider" data-id="element-856" data-mp="37t592glca8vi">
                  {program.duration}
                </span>
              </div>
              <div className="border-t border-black/10 pt-4" data-id="element-857" data-mp="32sh8b37b6do3">
                <p className="font-inter text-xs uppercase tracking-[0.25em] text-reach-black/60 mb-3" data-id="element-858" data-mp="2xuz9w6qx3guc">
                  Weekly Schedule
                </p>
                <ul className="space-y-2" data-id="element-859" data-mp="2ovc7bhmgc4zp">
                  {program.schedule.map(slot => <li key={slot} className="font-inter text-sm text-reach-black/80" data-id="element-860" data-mp="s2ir30qgpmzp">
                      {slot}
                    </li>)}
                </ul>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
/* ---------- WEEK AT A GLANCE ---------- */
function WeekAtAGlance() {
  const schedule = [{
    time: '9:00 to 10:15 AM',
    mon: 'ADVANCED 14+',
    tue: '',
    wed: 'ADVANCED 14+',
    thu: '',
    fri: ''
  }, {
    time: '10:30 to 11:30 AM',
    mon: 'PERF PREP 11 to 13',
    tue: '',
    wed: 'PERF PREP 11 to 13',
    thu: '',
    fri: ''
  }, {
    time: '1:00 to 2:15 PM',
    mon: '',
    tue: '',
    wed: '',
    thu: '',
    fri: 'ADVANCED 14+'
  }, {
    time: '2:30 to 3:30 PM',
    mon: '',
    tue: '',
    wed: '',
    thu: '',
    fri: 'PERF PREP 11 to 13'
  }, {
    time: '4:00 to 5:00 PM',
    mon: '',
    tue: 'FOUNDATIONS 8 to 10',
    wed: '',
    thu: 'FOUNDATIONS 8 to 10',
    fri: ''
  }, {
    time: '5:00 to 6:00 PM',
    mon: '',
    tue: 'PERF PREP 11 to 13',
    wed: '',
    thu: 'PERF PREP 11 to 13',
    fri: ''
  }, {
    time: '6:00 to 7:15 PM',
    mon: '',
    tue: 'ADVANCED 14+',
    wed: '',
    thu: 'ADVANCED 14+',
    fri: ''
  }];
  return <section className="bg-white py-20 md:py-28" data-id="element-861" data-mp="ax4nfdo4wp1w">
      <div className="max-w-container mx-auto px-4 md:px-8" data-id="element-862" data-mp="5zw5ne6wen16">
        <div className="text-center mb-12" data-id="element-863" data-mp="5yb6fb9n2fwz">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-864" data-mp="3egz9bn6jnma3">
            The Week at a Glance
          </p>
          <h2 className="font-bebas text-4xl md:text-6xl tracking-wide" data-id="element-865" data-mp="3acj8w1fp9729">
            Full Schedule
          </h2>
        </div>

        <div className="overflow-x-auto" data-id="element-866" data-mp="3jeinkn38rz21">
          <table className="w-full min-w-[640px] border-collapse" data-id="element-867" data-mp="3jdppeaicmhvi">
            <thead data-id="element-868" data-mp="2voekqhxvo3c3">
              <tr className="bg-reach-black text-white" data-id="element-869" data-mp="2vnvdbv5usxcb">
                <th className="font-bebas text-lg tracking-wider uppercase text-left p-4 border-r border-white/10" data-id="element-870" data-mp="2qqwlxkdkr4ht">
                  Time
                </th>
                <th className="font-bebas text-lg tracking-wider uppercase p-4 border-r border-white/10" data-id="element-871" data-mp="266mg5ivkuzu6">
                  Monday
                </th>
                <th className="font-bebas text-lg tracking-wider uppercase p-4 border-r border-white/10" data-id="element-872" data-mp="2f4yd02n1etv2">
                  Tuesday
                </th>
                <th className="font-bebas text-lg tracking-wider uppercase p-4 border-r border-white/10" data-id="element-873" data-mp="2k2837ki939jy">
                  Wednesday
                </th>
                <th className="font-bebas text-lg tracking-wider uppercase p-4 border-r border-white/10" data-id="element-874" data-mp="2t3xsajontwek">
                  Thursday
                </th>
                <th className="font-bebas text-lg tracking-wider uppercase p-4" data-id="element-875" data-mp="32usqmmf6kmgd">
                  Friday
                </th>
              </tr>
            </thead>
            <tbody data-id="element-876" data-mp="37vghn83et3al">
              {schedule.map((row, i) => <tr key={row.time} className={i % 2 === 0 ? 'bg-reach-gray' : 'bg-white'} data-id="element-877" data-mp="3cs6uznntxksb" data-mpi={i}>
                  <td className="font-inter text-sm font-semibold text-reach-black p-4 border-r border-black/5" data-id="element-878" data-mp="116xzlwu42u7r">
                    {row.time}
                  </td>
                  <td className="font-inter text-xs uppercase tracking-wider text-reach-black/80 text-center p-4 border-r border-black/5" data-id="element-879" data-mp="r8i47ho1wysg">
                    {row.mon}
                  </td>
                  <td className="font-inter text-xs uppercase tracking-wider text-reach-black/80 text-center p-4 border-r border-black/5" data-id="element-880" data-mp="1jwe38t13f2se">
                    {row.tue}
                  </td>
                  <td className="font-inter text-xs uppercase tracking-wider text-reach-black/80 text-center p-4 border-r border-black/5" data-id="element-881" data-mp="1a5jdheon1l27">
                    {row.wed}
                  </td>
                  <td className="font-inter text-xs uppercase tracking-wider text-reach-black/80 text-center p-4 border-r border-black/5" data-id="element-882" data-mp="22n5j8dfl5rfr">
                    {row.thu}
                  </td>
                  <td className="font-inter text-xs uppercase tracking-wider text-reach-black/80 text-center p-4" data-id="element-883" data-mp="u5217zdr5ogz">
                    {row.fri}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}
/* ---------- PERIODIZED PROGRAMMING ---------- */
function PeriodizedProgramming() {
  return <section className="bg-reach-black text-white py-20 md:py-28 relative overflow-hidden" data-id="element-884" data-mp="z6rdficpo86n">
      <div className="absolute -right-40 top-1/4 w-[50%] h-1 bg-reach-red opacity-30 rotate-[6deg]" data-id="element-885" data-mp="1d1ths11wtphc" />
      <div className="absolute -right-40 top-[34%] w-[35%] h-1 bg-reach-red opacity-20 rotate-[6deg]" data-id="element-886" data-mp="190rri9pz0nri" />

      <div className="max-w-container mx-auto px-4 md:px-8" data-id="element-887" data-mp="1huwf8k9t5j2t">
        <div className="text-center mb-12" data-id="element-888" data-mp="1hvfwdyrmw3fs">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-889" data-mp="1wrx8is7ndm3e">
            What Your Athlete Trains
          </p>
          <h2 className="font-bebas text-5xl md:text-6xl tracking-wide leading-none mb-4" data-id="element-890" data-mp="1run7efawblzq">
            Periodized Programming.
            <br data-id="element-891" data-mp="2bd1d33boaebe" />
            Every Day Has a Purpose.
          </h2>
          <p className="font-inter text-white/85 text-lg md:text-xl max-w-2xl mx-auto" data-id="element-892" data-mp="2ffxooa2spa5u">
            Speed plus strength plus recovery every session. Testing every 4
            weeks.
          </p>
        </div>

        <p className="font-inter text-white/85 text-base md:text-lg leading-relaxed max-w-3xl mx-auto text-center mb-12" data-id="element-893" data-mp="26hvr64i9sznb">
          Speed work and strength work are scheduled by day, not at random.
          Athletes work through a planned progression each week so the right
          qualities get trained at the right time.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-4xl mx-auto" data-id="element-894" data-mp="1noruea9ra6oh">
          <div className="bg-white/[0.04] border border-white/10 rounded-[4px] p-8" data-id="element-895" data-mp="18sak7mdayy3i">
            <h3 className="font-bebas text-2xl md:text-3xl tracking-wide mb-6 text-reach-red" data-id="element-896" data-mp="1dr3yvi4bsv59">
              Speed Focus by Day
            </h3>
            <ul className="space-y-3" data-id="element-897" data-mp="unjxzf84cokb">
              <li className="flex justify-between items-baseline border-b border-white/10 pb-2" data-id="element-898" data-mp="uolcjtocft6s">
                <span className="font-bebas text-lg tracking-wider" data-id="element-899" data-mp="ptp81u1x7dcs">
                  Mon and Tue
                </span>
                <span className="font-inter text-sm text-white/80" data-id="element-900" data-mp="fxm3yinid4n7">
                  Acceleration
                </span>
              </li>
              <li className="flex justify-between items-baseline border-b border-white/10 pb-2" data-id="element-901" data-mp="1dk1o5s7bkgeg">
                <span className="font-bebas text-lg tracking-wider" data-id="element-902" data-mp="18nb6j0fv9cqx">
                  Wed and Thu
                </span>
                <span className="font-inter text-sm text-white/80" data-id="element-903" data-mp="13lc53w3ospwm">
                  COD / Multidirectional
                </span>
              </li>
              <li className="flex justify-between items-baseline border-b border-white/10 pb-2" data-id="element-904" data-mp="3odxgpu4i4uc6">
                <span className="font-bebas text-lg tracking-wider" data-id="element-905" data-mp="3jdtb4z54tk0q">
                  Friday
                </span>
                <span className="font-inter text-sm text-white/80" data-id="element-906" data-mp="1yxbo3rwmivss">
                  Max Velocity
                </span>
              </li>
            </ul>
          </div>

          <div className="bg-white/[0.04] border border-white/10 rounded-[4px] p-8" data-id="element-907" data-mp="28uq4xsmglmlm">
            <h3 className="font-bebas text-2xl md:text-3xl tracking-wide mb-6 text-reach-red" data-id="element-908" data-mp="2dl6hlaigh46x">
              Strength Focus by Day
            </h3>
            <ul className="space-y-3" data-id="element-909" data-mp="2ij83e379nhm3">
              <li className="flex justify-between items-baseline border-b border-white/10 pb-2" data-id="element-910" data-mp="2imm3f4sgjeqd">
                <span className="font-bebas text-lg tracking-wider" data-id="element-911" data-mp="2mnxt1abbzzyk">
                  Monday
                </span>
                <span className="font-inter text-sm text-white/80" data-id="element-912" data-mp="2wk0uedyczukg">
                  Lower Body
                </span>
              </li>
              <li className="flex justify-between items-baseline border-b border-white/10 pb-2" data-id="element-913" data-mp="x7ygdj8i7se6">
                <span className="font-bebas text-lg tracking-wider" data-id="element-914" data-mp="1272n837yhe1c">
                  Wednesday
                </span>
                <span className="font-inter text-sm text-white/80" data-id="element-915" data-mp="2slk44akomx3z">
                  Upper Body
                </span>
              </li>
              <li className="flex justify-between items-baseline border-b border-white/10 pb-2" data-id="element-916" data-mp="31ntb4qgqs8cm">
                <span className="font-bebas text-lg tracking-wider" data-id="element-917" data-mp="2xm83bjj2ek9a">
                  Friday
                </span>
                <span className="font-inter text-sm text-white/80" data-id="element-918" data-mp="29w40vfhm4qjv">
                  Full Body
                </span>
              </li>
              <li className="flex justify-between items-baseline border-b border-white/10 pb-2" data-id="element-919" data-mp="24z3v75oodpta">
                <span className="font-bebas text-lg tracking-wider" data-id="element-920" data-mp="2ipqrkr6yr3m7">
                  Tue and Thu
                </span>
                <span className="font-inter text-sm text-white/80" data-id="element-921" data-mp="2dw4e4wsz6vpc">
                  Full Body
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}
/* ---------- TESTING AND RECOVERY ---------- */
function TestingAndRecovery() {
  const testDates = [{
    label: 'Jun 1',
    sub: 'Baseline'
  }, {
    label: 'Jun 29',
    sub: 'Mid Summer'
  }, {
    label: 'Jul 27',
    sub: 'Final'
  }];
  return <section className="bg-white py-20 md:py-28" data-id="element-922" data-mp="122u2muuci5d1">
      <div className="max-w-container mx-auto px-4 md:px-8" data-id="element-923" data-mp="1738762wqmx6b">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-924" data-mp="1utm3w6q9pk78">
          {/* Performance Testing */}
          <div className="bg-reach-gray rounded-[4px] p-8 md:p-10 border-l-4 border-reach-red" data-id="element-925" data-mp="1zsf6h440nqsm">
            <div className="flex items-center gap-3 mb-4" data-id="element-926" data-mp="1kvog1kcblpf5">
              <Target size={24} className="text-reach-red" data-id="element-927" data-mp="1kv6dk5z2eeys" />
              <h3 className="font-bebas text-2xl md:text-3xl tracking-wide uppercase leading-none" data-id="element-928" data-mp="1ptpzi6dnrqr5">
                Performance Testing . Every 4 Weeks
              </h3>
            </div>
            <p className="font-inter text-reach-black text-base leading-relaxed mb-6" data-id="element-929" data-mp="efvow4xm1bit">
              Three testing days across the summer. Same markers each time so
              progress is measured, not guessed at.
            </p>
            <div className="flex items-center justify-between gap-4 mb-6" data-id="element-930" data-mp="2c3g9xhuw0dck">
              {testDates.map(date => <div key={date.label} className="text-center" data-id="element-931" data-mp="27a4zz7us3ggf">
                  <p className="font-bebas text-3xl md:text-4xl text-reach-red tracking-wide leading-none mb-1" data-id="element-932" data-mp="22c3jmuoqlv8n">
                    {date.label}
                  </p>
                  <p className="font-inter text-xs uppercase tracking-[0.2em] text-reach-black/70" data-id="element-933" data-mp="1tcoqtol3l8kz">
                    {date.sub}
                  </p>
                </div>)}
            </div>
            <p className="font-inter text-sm text-reach-black/70 leading-relaxed italic" data-id="element-934" data-mp="1jesif4jjorqk">
              We test 10 yard, 30 yard, vertical jump, and broad jump. These are
              foundational markers commonly used in high level performance
              programs.
            </p>
          </div>

          {/* Recovery */}
          <div className="bg-reach-gray rounded-[4px] p-8 md:p-10 border-l-4 border-reach-red" data-id="element-935" data-mp="3lb1e19qxsivv">
            <div className="flex items-center gap-3 mb-4" data-id="element-936" data-mp="3q9l2bgt066re">
              <Calendar size={24} className="text-reach-red" data-id="element-937" data-mp="3v1w1ghfx5oiw" />
              <h3 className="font-bebas text-2xl md:text-3xl tracking-wide uppercase leading-none" data-id="element-938" data-mp="3v2e53z4wv50u">
                Recovery Included
              </h3>
            </div>
            <p className="font-inter text-reach-black text-base leading-relaxed mb-6" data-id="element-939" data-mp="32e073jdto8pa">
              Every membership includes access to INPOWERiQ on-site recovery
              zone after training. Athletes can cool down, recover, and come
              back ready for the next session.
            </p>
            <p className="font-inter text-reach-black text-base leading-relaxed" data-id="element-940" data-mp="3hazbkyddnlfj">
              Recovery is part of how athletes get better, not an upgrade.
            </p>
          </div>
        </div>
      </div>
    </section>;
}
/* ---------- MEMBERSHIP INCLUDES ---------- */
const INCLUDES = ['Access to the on-site recovery zone after every session.', 'Performance testing every 4 weeks across the summer.', 'Speed gates and jump mat testing for real progress data.', 'Periodized programming, never random workouts.', 'Capped small group training for individualized coaching.', 'Integrated speed and strength every session.'];
function MembershipIncludes() {
  return <section className="bg-reach-gray py-20 md:py-24" data-id="element-941" data-mp="20dhcws78ps54">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-942" data-mp="20gd8i9vm84qe">
        <div className="text-center mb-10" data-id="element-943" data-mp="1wc5lch4t2wua">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-944" data-mp="2acophd65hir6">
            Every Membership Includes
          </p>
          <h2 className="font-bebas text-4xl md:text-5xl tracking-wide leading-none" data-id="element-945" data-mp="25e52d9ftm0x8">
            What's Included
          </h2>
        </div>
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-4 bg-white rounded-[4px] p-6 md:p-8 border-l-4 border-reach-red" data-id="element-946" data-mp="azkmrb6cwvkp">
          {INCLUDES.map(item => <li key={item} className="flex items-start gap-3" data-id="element-947" data-mp="2mnfxvox4d7yk">
              <div className="w-6 h-6 bg-reach-red rounded-sm flex items-center justify-center shrink-0 mt-0.5" data-id="element-948" data-mp="2rmah2rz00yj7">
                <Check size={14} className="text-white" strokeWidth={3} data-id="element-949" data-mp="2cw35mw7esfs0" />
              </div>
              <span className="font-inter text-reach-black text-base" data-id="element-950" data-mp="2hv63nwoz1lqh">
                {item}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}
/* ---------- FINAL CTA ---------- */
function FinalCta() {
  return <section className="bg-reach-red py-16 md:py-20" data-id="element-951" data-mp="28t6o78tluppn">
      <div className="max-w-container mx-auto px-4 md:px-8 text-center" data-id="element-952" data-mp="1tzk52vao8072">
        <h2 className="font-bebas text-white text-5xl md:text-7xl tracking-wide mb-10" data-id="element-953" data-mp="1ywk10ddt3mkg">
          Reserve Your Spot.
        </h2>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-stretch sm:items-center max-w-md sm:max-w-none mx-auto" data-id="element-954" data-mp="3oct8c5cmipgv">
          <Link to="/pricing" className="inline-flex items-center justify-center bg-white text-reach-black font-inter font-semibold px-6 min-h-[44px] md:min-h-[48px] rounded-[4px] transition-all duration-200 ease-out hover:bg-reach-black hover:text-white uppercase tracking-wide text-sm md:text-base hover:-translate-y-[3px]" data-id="element-955" data-mp="3t90fu2ko490x">
            Enroll Now
          </Link>
          <Link to="/book" className="btn-secondary-dark sm:w-auto" data-id="element-956" data-mp="1ke5sp2dl9noa">
            Book Free Consultation
          </Link>
        </div>
      </div>
    </section>;
}